import * as React from 'react';
import styled from 'styled-components';

const ScrollableAreaWrapper = styled.div.attrs(props => ({
  tabIndex: '0'
}))`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  @media (max-width: 990px) {
    min-height: var(--graph-min-height);
  }
`;

interface IScrollableAreaProps {
  role?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const ScrollableArea = (props: IScrollableAreaProps): React.ReactElement => {
  return (
    <ScrollableAreaWrapper role={props.role} style={{ ...props.style }}>
      {props.children}
    </ScrollableAreaWrapper>
  );
};

export { ScrollableArea };
